<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper">
          <h1 class="bani-title mb-0">Transcription Guidelines</h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">
          Transcription Guidelines
        </div>
        <div class="static-content-paragraph">
          Transcription or transliteration is the practice of representing a
          written letter or a word from one script to another. It is also the
          system of rules for that practice. Simply put transcription and
          transliteration attempt to accurately capture the sound values across
          writing systems.
        </div>
        <div class="static-content-paragraph">
          Transliteration attempts to be exact. With the help of
          transliteration, an informed reader should be able to recreate the
          original spelling of the transliterated words. Transliteration is
          commonly employed in situations where high precision is required. It
          is necessary when using words or concepts expressed in a language with
          a script other than one’s own.
        </div>
        <div class="static-content-paragraph">
          Transcription is slightly different in that it takes into account the
          sound values represented by the writing systems. Transcription assists
          in speech and pronunciation, rather than the exact written
          representation. For example:
        </div>
        <div class="static-content-paragraph">
          <ul style="list-style-type: disc">
            <li>ਪਰਮਦਭੁਤੰ ‒ paramadabhutaṅa (transliteration)</li>
            <li>ਪਰਮਦਭੁਤੰ ‒ parmadbhutaṅ (transcription)</li>
            <li>Psychology - ਪਸਯਕੋਲੋਜੀ (transliteration)</li>
            <li>Psychology - ਸਾਈਕੌਲੋਜੀ (transcription)</li>
          </ul>
        </div>
        <div class="static-content-paragraph">
          If relations between letters and sounds are similar in both languages,
          transliteration may be nearly identical to its transcription.
          Transcription has a superficial attraction in that it is generally
          more readable, primarily because it expresses sounds associated with
          one script using another script.
        </div>
        <div class="static-content-paragraph">
          In regards to Gurmukhi, transcription proves utilitarian because the
          script is highly phonetic. Because this project concerns the spoken
          aspects of the script, transcription is utilized throughout this
          volume. When writing proper nouns outside of the context of line
          meanings and footnotes, common spellings will be used instead of
          transcription-accurate spellings.
        </div>
        <div class="static-content-paragraph">
          Ex: Duni Cand → Duni Chand <br />
          Shekh Ibrahim → Sheikh Ibrahim
        </div>
        <div class="static-content-paragraph">
          Considering that the pronunciation of Guru Granth Sahib is closely
          related to its interpretation, an accurate and standardized
          transcription system assumes a very important role since meanings tend
          to change with even a slight variation in tone or nasalization. An
          accurate transcription would thus supplement the correct articulation
          of phones.
        </div>
        <div class="static-content-paragraph">
          Developing a standardized transcription would aid both the Sikh
          Diaspora and the western scholars, who wish to better grasp the
          language of Guru Granth Sahib. A universally accepted system will go a
          long way in advancing the language and its understanding. Due to
          shortcomings in the English language in general, and the Roman script
          in particular, it has proved challenging to develop a technique for
          transcription with the capacity to consistently and accurately
          transfer text from Gurmukhi characters to Roman characters. Numerous
          attempts have been made in the past, and gratefully, modern linguistic
          standards and thorough research have finally made Gurmukhi-Roman
          transcription a reality.
        </div>
        <div class="static-content-paragraph">
          A majority of the characters used to transcribe Gurmukhi into English
          have been derived from a universally recognized system of linguistics.
          For those Gurmukhi letters lacking an equivalent representation in the
          Roman alphabet, a symbol comparable to a character with an associable
          sound has been generated to represent those alphabets. As each
          Gurmukhi letter represents a unique audible sound, it has been
          assigned its own symbol for transcription into the Roman script.
        </div>

        <div class="static-content-heading-wrapper">
          Transcription Guidelines
        </div>

        <div class="static-content-paragraph">
          Since speech precedes writing, identifying speech sounds is vital for
          establishing correct pronunciation of a word. The sound being produced
          while uttering a word is more important than the rules in establishing
          the correct transcription output. Hence the pronunciation precedes the
          transcription rules. Transcription rules only help in understanding
          and establishing commonly identifiable patterns.
        </div>
        <div class="table-responsive">
          <table
          mat-table
          [dataSource]="dataSource"
          class="sggs-table mat-elevation-z0 demo-table table"
        >
          <ng-container
            *ngFor="let column of columns; let i = index"
            [matColumnDef]="column.columnDef"
          >
            <!-- [class.firstHeading]="i === 0" -->
            <th
              mat-header-cell
              *matHeaderCellDef
              class="sggs-table-row-outline sggs-table-header"
            >
              {{ column.header }}
            </th>
            <td
              [class.no-border-bottom]="
                column.cell(row) === 'R1' ||
                column.cell(row) === 'ਸ (s)' ||
                column.cell(row) === 'ਙ (ṅ)'
              "
              mat-cell
              *matCellDef="let row"
              class="sggs-table-row-outline"
            >
              {{ column.cell(row) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        </div>
       

        <div class="static-content-heading-wrapper">Consonants</div>
        <div class="static-content-paragraph">
          1. The consonants begin from s (ਸ), and continue through ṛ (ੜ). <br />
          2. In pronunciation, a consonant that stands independent of a vowel
          character will be followed by an implicit “a” (muktā).<br />
          <span class="static-content-indent"
            >a. The above statement is only true for consonants devoid of vowel
            characters. However, if the consonant is the final letter of the
            word, then the implicit “a” is omitted in transcription. <br />
            <span class="static-content-indent">
              <b>Example 1:</b> ਨਦਰ (na + da + ra = nadar) <br />
              <b>Example 2:</b> ਸਤ (sa + ta = sat) <br />
            </span>
          </span>
          <span class="static-content-indent">
            b. The implicit “a” is applicable at the end of a single character
            word. <br />
            <span class="static-content-indent">
              <b>Example 1:</b> ਨ (na) <br />
              <b>Example 2:</b> ਤ (ta) <br />
            </span>
          </span>
          3. There are instances where the implicit “a” is overlooked. In these
          cases, the “a” can be omitted as it aids in pronunciation. The
          inclusion of the implicit “a” is not inaccurate, but more functional
          <span class="static-content-indent">
            Example 1: ਦਰਸਨ (da + ra + sa + na = darsan) <br />
            Example 2: ਕਰਤਾ (ka + ra + tā = kartā)
          </span>
          4. When a consonant with a short “a” is followed by a vowel character
          supported by a vowel base (specifically ਉ and ਇ), then the vowel
          symbol will be indicated by a corresponding dieresis (ï or ü) vowel.
          <span class="static-content-indent">
            Example 1: ਸਉ (sa + u = saü) <br />
            Example 2: ਗਇ (ga + i = gaï)
          </span>

          <div class="table-responsive">
            <table mat-table [dataSource]="dataSourceConsonants" class="sggs-table mat-elevation-z0 demo-table">
            <ng-container *ngFor="let column of consonantsColumns; let i = index;" [matColumnDef]="column.columnDef">
              <th [class.firstHeading]="i === 0" mat-header-cell *matHeaderCellDef class="sggs-table-row-outline sggs-table-header">
                {{column.header}}
              </th>
              <td mat-cell *matCellDef="let row" [class.no-left-border]="row.id === 2"  class="sggs-table-row-outline">
                {{column.cell(row)}} 
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedConsonantsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedConsonantsColumns;"></tr>
            </table>
          </div>
        </div>

        <div class="static-content-paragraph"></div>

        <div class="static-content-heading-wrapper">Vowels</div>
        <div class="static-content-paragraph">
          1. There are three vowel bases (ੳ, ਅ, ੲ). <br />
          2. In addition to the implicit “a” that follows consonants independent
          of vowels, there are ten vowel characters (see vowel chart). <br />
          3. Of the three vowel bases, only ਅ can stand independent of another
          vowel character.<br />
          <span class="static-content-indent">
            <b>Example 1:</b> ਅਗਨ (a + ga + na = agan) <br />
            <b>Example 2: </b> ਅਕਾਲ (a + kā + la = akāl) <br />
          </span>

          4. If a vowel character is directly followed by another vowel base and
          character, then the implicit “a” will be omitted. <br />
          <span class="static-content-indent">
            <b>Example 1:</b> ਜਾਇ (jā + i = jāi) <br />
            <b>Example 2: </b> ਕੀਓ (kī + o = kīo) <br />
          </span>

          5. If a vowel character combines with a vowel base to produce the
          first letter in the word, there will be no “a” preceding the vowel.
          <br />
          <span class="static-content-indent">
            <b>Example 1:</b> ਊਪਰਹੁ (ū + pa + ra + hu = ūparahu) <br />
            <b>Example 2: </b> ਆਸਣੁ (ā + sa + ṇu = āsaṇu) <br />
          </span>
          6. If a vowel character is present with a consonant rather than a
          vowel base, then there will be no “a” between the consonant and the
          vowel. <br />
          <span class="static-content-indent">
            <b>Example 1:</b> ਸੂਰਾ (sū + rā = sūrā) <br />
            <b>Example 2: </b> ਮੋਹਿ (mo + hi = mohi) <br />
          </span>
        </div>

        <div class="static-content-heading-wrapper">ṬIPPĪ (<img alt="Tippi Image" src="/assets/images/tippi.svg" style="height:19px;">)</div>
        <div class="static-content-paragraph">
          1. When a ṭippī is representing one of the five sounds (ṇ, ṅ, ñ, n,
          m), it will not be followed by an implicit “a.” <br />
          <b>Example 1:</b> ਖੰਡ (kha + ṇ + ḍa = khaṇḍ) <br />
          <b>Example 2: </b> ਚੰਗਾ (ca + ṅ + gā = caṅgā) <br />

          2. If a ṭippī is representing one of the five sounds (ṇ, ṅ, ñ, n, m),
          and the letter following the ṭippī falls within rows 2-6 (consonant
          chart), then the ṭippī will make the sound of the last letter in the
          corresponding row. <br />
          <b>Example 1:</b> ਅੰਤ (a + n + ta = ant) <br />
          <b>Example 2: </b> ਸੰਗਤਿ (sa + ṅ + ga + ti = saṅgati) <br />
          <span class="static-content-indent">
            a. If a letter following the ṭippī falls in row 1 or 7 (consonant
            chart), then the ṭippī predominantly makes a “n” sound (consonant
            nasalization) and occasionally a “ṁ” sound (vowel nasalization).
            <span class="static-content-indent">
              <b>Example 1:</b> ਸੰਸਾ (sa + n + sā = sansā) <br />
              <b>Example 2:</b> ਮੁੰਲਾ (mu + ṁ + lā = muṁlā) <br />
            </span>
            b. When a ṭippī represents one of the five sounds (ṇ, ṅ, ñ, n, m),
            and the letter emphasized by the ṭippī represents the same sound (ṇ,
            ṅ, ñ, n, m), then it will create a double sound (compound), and
            should be transcribed accordingly.
            <span class="static-content-indent">
              <b>Example 1:</b> ਅੰਮ੍ਰਿਤ (a + mma + ri + ta = ammrit) <br />
              <b>Example 2:</b> ਮੰਨੀਐ (ma + nnī + ai = mannīai) <br />
            </span>
          </span>
          3. If a ṭippī is at the end of the word, and therefore unsupported by
          another consonant, then the default sound is “aṅ.”
          <span class="static-content-indent">
            <b>Example 1:</b> ਸੈਭੰ (sai + bhaṅ = saibhaṅ) <br />
            <b>Example 2:</b> ਕਰਮੰ (ka + ra + maṅ = karmaṅ) <br />
          </span>
          <span class="static-content-indent">
            If a ṭippī concludes a term in a compound word, then the ṭippī will
            create the “ṅ” sound.
            <span class="static-content-indent">
              <b>Example 1:</b> ਅਹੰਕਾਰ (a + ha + ṅ + kā + ra = ahaṅkār) <br />
              <b>Example 2:</b> ਅਹੰਬੁਧਿ (a + ha + ṅ + bu + dhi = ahaṅbudhi)
              <br />
            </span>
          </span>
          4. All vowel nasalization are denoted by “ṁ.” <br />
          <b>Example:</b> ਤੂੰ (tū + ṁ = tūṁ) <br />
          5. The ṭippī has two possible connotations. It commonly symbolizes an
          additional sound incorporating one of five characters (ṇ, ṅ, ñ, n, m),
          and sometimes denotes a nasalization (ṁ). Identification of correct
          usage in various instances can only be determined with the knowledge
          of the language.
        </div>

        <div class="static-content-heading-wrapper">BINDĪ (<img alt="Bindi Image" src="/assets/images/bindi.svg" style="height:19px;">)</div>
        <div class="static-content-paragraph">
          1. The bindī can play two different roles. Predominantly, it calls for
          vowel nasalization (and in a few instances, consonant nasalization)
          that produces a “ṁ” sound. It occasionally forms a “n” sound. One can
          know the role of bindī only with an understanding of the language.
          <br />
          2. When creating a “n” sound, there will be no implicit “a” sound
          following the “n” sound. <br />
          <span class="static-content-indent">
            <b>Example:</b> ਸਾਂਤਿ (sā + ṁ + ti = sāṁti) <br />
          </span>
          3. All vowel nasalizations are denoted by “ṁ.”<br />
          <span class="static-content-indent">
            <b>Example 1:</b> ਤੂਹੈਂ (tū + ha + aiṁ = tūhaiṁ) <br />
            <b>Example 2:</b> ਹਾਂ (ha + āṁ = hāṁ) <br />
          </span>
        </div>
        <div class="static-content-heading-wrapper">VISARG (<img alt="Visara Image" src="/assets/images/visarg.svg" style="height:19px;">)</div>
        <div class="static-content-paragraph">
          The Visarg is represented by a “ḥ.” It is pronounced as a softer “h,”
          and an implicit “a” precedes the “ḥ.” <br />
          <span class="static-content-indent">
            <b>Example 1:</b> ਦ੍ਰਿੜੰਤਣਃ (dri + ṛa + n + ta + ṇa + ḥa =
            driṛantaṇaḥ)<br />
            <b>Example 2:</b> ਲਿਖੵਣਃ (li + kha + ya + ṇa + ḥa = likhyaṇaḥ)
            <br />
          </span>
        </div>
        <div class="static-content-heading-wrapper">SUBSCRIPTS</div>
        <div class="static-content-paragraph">
          1. There are eight subscripts used within Guru Granth Sahib. <br />
          2. The subscript appears below the consonant. <br />
          3. The subscript is pronounced directly after the consonant above it;
          there is no implicit “a” between the two. <br />
          <span class="static-content-indent">
            <b>Example 1: </b> (ascaraj) <br />
            <b>Example 2: </b> (dastagīrī) <br />
          </span>
          3. If a vowel supports a consonant and the subscript, then the
          subscript will follow the consonant but precede the vowel in
          pronunciation. <br />
          <span class="static-content-indent">
            <b>Example 1: </b> (bisṭā) <br />
            <b>Example 2: </b> (snehaṅ) <br />
          </span>

          <div class="table-responsive">
            <table mat-table [dataSource]="subscriptsDataSource" class="sggs-table mat-elevation-z0 demo-table">
            <ng-container *ngFor="let column of subscriptsColumns; let i = index;" [matColumnDef]="column.columnDef">
              <th [class.firstHeading]="i === 0" mat-header-cell *matHeaderCellDef class="sggs-table-row-outline sggs-table-header">
                {{column.header}}
              </th>
              <td mat-cell *matCellDef="let row" class="sggs-table-row-outline">
                {{column.cell(row)}}
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedSubscriptsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedSubscriptsColumns;"></tr>
            </table>
          </div>

        </div>
        <div class="static-content-heading-wrapper">HALANT-LIKE SYMBOL ( )</div>
        <div class="static-content-paragraph">
          Appearance of this symbol in Guru Granth Sahib is represented through
          the same in the Roman script as well. <br />
          <span class="static-content-indent">
            <b>Example 1: </b> ਜਿਨੑੀ (ji + n̖ī = jin̖ī) <br />
            <b>Example 2: </b> ਧਿਆਵਨਿੑ (dhi + ā + va + n̖i = dhiāvan̖i)<br />
          </span>
        </div>
        <div class="static-content-heading-wrapper">PROLONGATION (ਅ)</div>
        <div class="static-content-paragraph">
          When appearing at the end of a word and directly following a vowel
          character, the A represents a prolongation of the sound preceding it.
          <br />
          <span class="static-content-indent">
            <b>Example 1: </b> ਜੀਅ (jī + a = jīa) <br />
            <b>Example 2: </b> ਲੋਅ (lo + a = loa) Cardinal Numbers
          </span>
          <div class="table-responsive">
            <table mat-table [dataSource]="cardinalsDataSource" class="sggs-table mat-elevation-z0 demo-table">
            <ng-container *ngFor="let column of cardinalsColumns; let i = index;" [matColumnDef]="column.columnDef">
              <th [class.firstHeading]="i === 0" mat-header-cell *matHeaderCellDef class="sggs-table-row-outline sggs-table-header">
                {{column.header}}
              </th>
              <td mat-cell *matCellDef="let row" class="sggs-table-row-outline">
                {{column.cell(row)}}
              </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedCardinalsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedCardinalsColumns;"></tr>
            </table>
          </div>  


        </div>
        <div class="static-content-heading-wrapper">NUMERALS</div>
        <div class="static-content-paragraph">
          Gurmukhi numerals are transcribed through the respective Roman digits
          as per the table above. However, a number may be properly spelt in the
          transcription if the original in the Gurmukhi script indicates so.
          <br />
          <span class="static-content-indent">
            <b>Example 1: </b> ੧ (1)<br />
            <b>Example 2: </b> ਇਕੁ (i + ku = iku) <br />
          </span>
        </div>
        <div class="static-content-heading-wrapper">ADOPTIONS</div>
        <div class="static-content-paragraph">
          1. <b> Farsi </b> <br />
          <span class="static-content-indent">
            a. If an equivalent sound for a Farsi inspired letter exists in the
            Roman script, then that Roman letter is used in the transcription.
            <br />
            <span class="static-content-indent">
              <b>Example 1: </b> ਫ਼ (f) <br />
              <b>Example 2: </b> ਜ਼ (z) <br />
            </span>

            b. If there is no corresponding sound already inscribed in the Roman
            alphabet, then the sound will be indicated with a line underneath
            the corresponding Roman letters. <br />
            <span class="static-content-indent">
              <b>Example 1: </b> ਗ਼ (gh) <br />
              <b>Example 2: </b> ਖ਼ (kh) <br />
            </span>

            c. The contemporary version of the Gurmukhi script has adopted five
            new sounds that are indicated with a dot under the corresponding
            Gurmukhi letter: ਗ਼ (gh), ਜ਼ (z), ਫ਼ (f), ਖ਼ (kh), ਸ਼ (sh). <br />
            d. Beside these five, the Gurmukhi script has later adopted another
            sound represented by ਲ਼ (ḷ). <br />
          </span>
          2. <b> Adhak (ѳੱ ) </b> <br />
          <span class="static-content-indent">
            1. The adhak conveys which syllable should be stressed. Though used
            within secondary writings of the Sikhs, the adhak came into use
            after the Guru Granth Sahib was compiled. Therefore, it does not
            appear within the text of the Guru Granth Sahib. <br />
            b. Gurmukhi characters emphasized by the adhak will be written twice
            in the Roman script. <br />
            <b>Example: </b> ਵਡਮੁੱਲਾ (va + ḍa + mu + llā = vaḍmullā) <br />
            c. If more than one Roman alphabet is utilized to represent a
            Gurmukhi letter that is emphasized by the adhak, then only the first
            letter will be doubled. <br />
            <b>Example: </b> ਭੱਠੀ (bha + ṭṭhī = bhaṭṭhī)
          </span>
        </div>

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
